// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".block[data-v-cb5ab3a0]{height:1.5rem;width:100%}.el-carousel__item h3[data-v-cb5ab3a0]{color:#475669;line-height:1.5rem;margin:0;opacity:.75;text-align:center}.el-carousel__item[data-v-cb5ab3a0]:nth-child(2n){background-color:#99a9bf}.el-carousel__item[data-v-cb5ab3a0]:nth-child(odd){background-color:#d3dce6}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
